module.exports = __webpack_public_path__ + "img/image 24.de5468fe.svg";